import type { Site } from '@/types/site';

interface PipelineDetailTabProps {
  site: Site;
}

export default function PipelineDetailTab({
  site,
}: Readonly<PipelineDetailTabProps>) {
  return (
    <div className="space-y-6">
      {/* 급수 배관 정보 */}
      <div className="bg-gray-50 rounded-xl p-6">
        <h4 className="text-lg font-semibold text-gray-900 mb-4">
          급수 배관 정보
        </h4>
        {site.waterSupplyPipelineInfo &&
        site.waterSupplyPipelineInfo.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {site.waterSupplyPipelineInfo.map((pipeline, index) => (
              <div
                key={index}
                className="bg-white rounded-lg p-4 border border-blue-200"
              >
                <h5 className="font-semibold text-gray-900 mb-3">
                  급수 배관 {index + 1}
                </h5>
                <div className="space-y-2 text-sm">
                  {pipeline.type && (
                    <div className="flex justify-between">
                      <span className="text-gray-600">배관 종류:</span>
                      <span className="text-gray-900">{pipeline.type}</span>
                    </div>
                  )}
                  {pipeline.diameter && (
                    <div className="flex justify-between">
                      <span className="text-gray-600">배관 직경:</span>
                      <span className="text-gray-900">
                        {pipeline.diameter}mm
                      </span>
                    </div>
                  )}
                  {pipeline.extension && (
                    <div className="flex justify-between">
                      <span className="text-gray-600">배관 연장:</span>
                      <span className="text-gray-900">
                        {pipeline.extension.toLocaleString()}m
                      </span>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-8">
            <i className="ri-git-branch-line text-4xl text-gray-400 mb-2"></i>
            <p className="text-gray-500">등록된 급수 배관 정보가 없습니다.</p>
          </div>
        )}
      </div>

      {/* 배수 배관 정보 */}
      <div className="bg-gray-50 rounded-xl p-6">
        <h4 className="text-lg font-semibold text-gray-900 mb-4">
          배수 배관 정보
        </h4>
        {site.drainageSupplyPipelineInfo &&
        site.drainageSupplyPipelineInfo.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {site.drainageSupplyPipelineInfo.map((pipeline, index) => (
              <div
                key={index}
                className="bg-white rounded-lg p-4 border border-green-200"
              >
                <h5 className="font-semibold text-gray-900 mb-3">
                  배수 배관 {index + 1}
                </h5>
                <div className="space-y-2 text-sm">
                  {pipeline.type && (
                    <div className="flex justify-between">
                      <span className="text-gray-600">배관 종류:</span>
                      <span className="text-gray-900">{pipeline.type}</span>
                    </div>
                  )}
                  {pipeline.diameter && (
                    <div className="flex justify-between">
                      <span className="text-gray-600">배관 직경:</span>
                      <span className="text-gray-900">
                        {pipeline.diameter}mm
                      </span>
                    </div>
                  )}
                  {pipeline.extension && (
                    <div className="flex justify-between">
                      <span className="text-gray-600">배관 연장:</span>
                      <span className="text-gray-900">
                        {pipeline.extension.toLocaleString()}m
                      </span>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-8">
            <i className="ri-arrow-down-line text-4xl text-gray-400 mb-2"></i>
            <p className="text-gray-500">등록된 배수 배관 정보가 없습니다.</p>
          </div>
        )}
      </div>

      {/* 수원 정보 */}
      {site.waterSource && site.waterSource.length > 0 && (
        <div className="bg-gray-50 rounded-xl p-6">
          <h4 className="text-lg font-semibold text-gray-900 mb-4">
            수원 정보
          </h4>
          <div className="space-y-4">
            {site.waterSource.map((source, index) => (
              <div key={index} className="bg-white rounded-lg p-4 border">
                <h5 className="font-semibold text-gray-900 mb-3">
                  수원 {index + 1}
                </h5>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
                  {source.date && (
                    <div className="flex justify-between">
                      <span className="text-gray-600">설정 날짜:</span>
                      <span className="text-gray-900">{source.date}</span>
                    </div>
                  )}
                  {source.reason && (
                    <div className="flex justify-between">
                      <span className="text-gray-600">설정 사유:</span>
                      <span className="text-gray-900">{source.reason}</span>
                    </div>
                  )}
                  {source.cost && (
                    <div className="flex justify-between">
                      <span className="text-gray-600">비용:</span>
                      <span className="text-gray-900">{source.cost}</span>
                    </div>
                  )}
                  {source.address && (
                    <div className="flex justify-between">
                      <span className="text-gray-600">위치:</span>
                      <span className="text-gray-900">{source.address}</span>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
